import { ChargeableFlow } from '../types/configuration';

export const checkPaymentRequired = (
  configuration?: ChargeableFlow
): boolean => {
  if (!configuration) {
    return true;
  }
  const { fee, custom_fee, fee_override, custom_fee_multiple_answers } =
    configuration;
  return (
    (fee && fee !== 0) ||
    !!custom_fee ||
    !!fee_override ||
    !!custom_fee_multiple_answers
  );
};
